'use strict';

// Constructor
var Header = function () {
    $('.slide2').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.home .header').removeClass('shrink');
        } else {
            $('.home .header').addClass('shrink');
        }
    }, {
        offset: $('.slide1').height() / window.innerHeight * 100 * 0.87 + '%'
    });

    $('.slide2').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.home .menu-trigger').removeClass('dark');
        } else {
            $('.home .menu-trigger').addClass('dark');
        }
    }, {
        offset: '10%'
    });
    $('.slide5').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.home .menu-trigger').addClass('dark');
        } else {
            $('.home .menu-trigger').removeClass('dark');
        }
    }, {
        offset: '10%'
    });
};

module.exports = Header;
